import { useEffect, useState } from "react";
import styled from "styled-components";
import { FormattedMessage, useIntl } from "react-intl";
import useGlobal from "../../../../hooks/useGlobal";
import { getFix2 } from "../../../../utils/utils";
import { getRTPrice } from "../../../../api";

export default function Runway() {
  const [rtPrice, setRtPrice] = useState(1);
  const { userInfo } = useGlobal();
  const intl = useIntl();


  useEffect(() => {
    loadRTPrice();
  }, []);
  const loadRTPrice = async () => {
    const res = await getRTPrice();
    setRtPrice(res.data);
  };
  const formater = (num) =>{
    return (num /100).toFixed(2)
  }
  return (
    <Wrapper>
      <Content>
        <Col style={{ marginRight: "1.5rem", width: "28%" }}>
          <div><FormattedMessage  id="当前使用装备数"/></div>
          <Way>{(userInfo && userInfo.bind_num) || 0}</Way>
        </Col>
        <Divider />
        <Col>
          <div>
          <FormattedMessage  id="可用装备"/>
            {" "}
            <strong>
              {userInfo ?  userInfo.equips.length - userInfo.bind_num : "-"}
            </strong>
          </div>
          <div>
          <FormattedMessage  id="总装备数"/>{" "}
            <strong>
            {userInfo ? userInfo.equips.length : "-"}
            </strong>
          </div>
        </Col>
        <Divider />
        <Col>
          <Fun>
            <span>
              <FormattedMessage id="pages.home.specialty_num" />
            </span>{" "}
            <strong>{userInfo ? formater(userInfo.specialty): "-"}</strong>
          </Fun>
          <Fun>
            <span>
              <FormattedMessage id="pages.home.aesthetic_num" />
            </span>{" "}
            <strong>{userInfo ? formater(userInfo.aesthetic) : "-"}</strong>
          </Fun>
          <Fun>
            <span>
              <FormattedMessage id="pages.home.comfort_num" />
            </span>{" "}
            <strong>{userInfo? formater(userInfo.comfort):"-"}</strong>
          </Fun>
        </Col>
      </Content>
      <Profit>
        <span>
          <FormattedMessage id="pages.home.today_pre_profit" />
        </span>
        <span className="num">
          {userInfo && userInfo.anticipated_income !== undefined
            ? getFix2(userInfo.anticipated_income)
            : "--"}{" "}
          RT
          {userInfo && getFix2(userInfo.anticipated_income * rtPrice)
            ? "($" + getFix2(userInfo.anticipated_income * rtPrice) + ")"
            : ""}
        </span>
      </Profit>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  background: #f4f5f6;
  box-shadow: .0rem .0rem 2px rgba(0, 0, 0, 0.08);
  border-radius: 2.0rem;
  font-style: normal;
  font-weight: 400;
  font-size: 1.2rem;
  line-height: 1.4rem;

  color: #969696;
  padding: 2.2rem 1.4rem 1.0rem;
  text-align: center;
  margin-top: 2.0rem;
`;
const Content = styled.div`
  display: flex;
  justify-content: space-around;
  strong {
    color: #000000;
    font-style: normal;
    font-weight: 500;
    font-size: 1.3rem;
    line-height: 1.3rem;
  }
`;

const Col = styled.div`
  width: 33%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const Divider = styled.div`
  width: 1px;
  background: #c4c4c4;
`;

const Profit = styled.div`
  background: #ffffff;
  border-radius: 1.8rem;
  padding: .7rem 0;
  margin-top: 1.2rem;
  text-align: center;
  font-style: normal;
  font-weight: 400;
  font-size: 1.2rem;
  line-height: 1.4rem;

  color: #969696;
  .num {
    margin-left: 5.0rem;
    font-style: normal;
    font-weight: 500;
    font-size: 1.3rem;
    line-height: 1.3rem;

    color: #fc7b2b;
  }
`;

const Fun = styled.div`
  &:not(:last-child) {
    margin-bottom: .5rem;
  }
  display: flex;
  span {
    width: 5.0rem;
    display: inline-block;
    text-align: right;
  }
  strong {
    flex: 1;
  }
`;

const Way = styled.div`
  background: #fc7b2b;
  border-radius: 1.8rem;
  padding: .9rem 0;
  font-style: normal;
  font-weight: 500;
  font-size: 1.3rem;
  line-height: 1.3rem;
  color: #ffffff;
`;
